import React from "react";

export default function EmpTimesheets() {
  const timesheets = [
    {
      date: "12 Jan 2025",
      day: "Monday",
      hours: "8 hrs",
      task: "Frontend Development",
      project: "HR Portal",
      status: "Completed",
    },
    {
      date: "11 Jan 2025",
      day: "Sunday",
      hours: "7 hrs",
      task: "API Integration",
      project: "HR Portal",
      status: "In Progress",
    },
    {
      date: "10 Jan 2025",
      day: "Saturday",
      hours: "6 hrs",
      task: "Database Setup",
      project: "HR Portal",
      status: "Pending",
    },
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case "Completed":
        return "bg-green-500 text-white";
      case "In Progress":
        return "bg-yellow-400 text-gray-800";
      case "Pending":
        return "bg-red-500 text-white";
      default:
        return "bg-gray-200 text-gray-800";
    }
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h2 className="text-3xl font-bold mb-6 text-gray-800">Timesheets</h2>

      <div className="bg-white shadow-lg rounded-2xl overflow-x-auto">
        <table className="w-full min-w-[700px]">
          <thead className="bg-gradient-to-r from-blue-500 to-indigo-500 text-white">
            <tr>
              <th className="p-3 text-left">Date</th>
              <th className="p-3 text-left">Day</th>
              <th className="p-3 text-left">Hours Worked</th>
              <th className="p-3 text-left">Task</th>
              <th className="p-3 text-left">Project</th>
              <th className="p-3 text-left">Status</th>
            </tr>
          </thead>
          <tbody>
            {timesheets.map((ts, idx) => (
              <tr key={idx} className="border-b hover:bg-gray-50 transition-colors">
                <td className="p-3">{ts.date}</td>
                <td className="p-3">{ts.day}</td>
                <td className="p-3">{ts.hours}</td>
                <td className="p-3">{ts.task}</td>
                <td className="p-3">{ts.project}</td>
                <td className="p-3">
                  <span
                    className={`px-3 py-1 rounded-full text-sm font-semibold ${getStatusColor(ts.status)}`}
                  >
                    {ts.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
